// extracted by mini-css-extract-plugin
module.exports = {"btn-loader-wrapper":"styles_btn-loader-wrapper__3Ns22","show":"styles_show__3bfo4","lds-spinner":"styles_lds-spinner__2vI0c"};